import { render, staticRenderFns } from "./PerSend.vue?vue&type=template&id=530facc3&scoped=true"
import script from "./PerSend.vue?vue&type=script&lang=js"
export * from "./PerSend.vue?vue&type=script&lang=js"
import style0 from "./PerSend.vue?vue&type=style&index=0&id=530facc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530facc3",
  null
  
)

export default component.exports